// src/components/NotFound.tsx
// FULL CLEAN 404 PAGE — Perfect match to your Viral Visible style
// Pink accents, dark/light mode, Lucide icons, sleek modern look

import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Play } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-6 overflow-hidden">
      <div className="max-w-lg w-full text-center">
        {/* Big 404 */}
        <div className="relative mb-8">
          <div className="text-[220px] font-black text-slate-100 dark:text-slate-900 select-none leading-none tracking-[-20px]">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-8xl opacity-30">
              <Play size={120} className="text-pink-500" />
            </div>
          </div>
        </div>

        <h1 className="text-5xl font-bold text-slate-800 dark:text-white mb-4 tracking-tight">
          Page not found
        </h1>
        
        <p className="text-xl text-slate-500 dark:text-slate-400 mb-10 max-w-sm mx-auto">
          Oops! Looks like this video link got lost in the feed.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="group flex items-center justify-center gap-3 bg-pink-600 hover:bg-pink-700 text-white font-semibold px-8 py-4 rounded-2xl transition-all shadow-lg shadow-pink-500/30 hover:shadow-xl hover:shadow-pink-500/40 active:scale-95"
          >
            <Home size={22} />
            Back to Feed
          </Link>

          <button
            onClick={() => window.history.back()}
            className="flex items-center justify-center gap-3 border border-slate-300 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-700 dark:text-slate-300 font-semibold px-8 py-4 rounded-2xl transition-all"
          >
            <ArrowLeft size={22} />
            Go Back
          </button>
        </div>

        <p className="mt-12 text-sm text-slate-400 dark:text-slate-500">
          Viral Visible • Share more viral moments
        </p>
      </div>
    </div>
  );
}